import { render, staticRenderFns } from "./FormattedPercentageInput.vue?vue&type=template&id=f47faca4&scoped=true"
import script from "./FormattedPercentageInput.vue?vue&type=script&lang=js"
export * from "./FormattedPercentageInput.vue?vue&type=script&lang=js"
import style0 from "./FormattedPercentageInput.vue?vue&type=style&index=0&id=f47faca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47faca4",
  null
  
)

export default component.exports